import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { RequestLoaderService } from '../services/request-loader.service';

@Injectable()
export class RequestLoaderInterceptor implements HttpInterceptor {

    constructor(private requestLoaderService: RequestLoaderService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.method !== 'GET' || request.responseType === 'blob') {
            this.requestLoaderService.add(decodeURI(request.url));
        }
        return next.handle(request)
            .pipe(
                tap(
                    (event: HttpEvent<any>) => {
                        if (event instanceof HttpResponse && (request.method !== 'GET' || request.responseType === 'blob')) {
                            this.requestLoaderService.remove(decodeURI(event.url));
                        }
                    },
                    (err: HttpEvent<any>) => {
                        if (err instanceof HttpErrorResponse && (request.method !== 'GET' || request.responseType === 'blob')) {
                            this.requestLoaderService.remove(decodeURI(err.url));
                        }
                    }
                )
            );
    }

}
